module.exports = __webpack_public_path__ + "img/ico-dash-cuotas.162aa128.svg";